import React, { useState } from 'react';
import { Home, Waves, LogIn, Mail, Phone, Menu, X, Gift } from 'lucide-react';

const PremiumNavbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const navLinks = [
    { name: 'Home', url: '/', icon: <Home size={18} /> },
    // { name: 'Destinatons', url: '#destinaton', icon:  <MapPinned size={18} />},
    { name: 'About Us', url: 'about', icon: <Waves size={18} /> },
    { name: 'Packages', url: 'packages', icon: <Waves size={18} /> },
    // { name: 'Login', url: 'login', icon: <LogIn size={18} /> },
    { name: 'Contact', url: 'contact', icon: <Mail size={18} /> },
    { name: 'Login', url: 'login', icon: <LogIn size={18} /> },
  ];

  const phoneNumber = "+917977600563";

  return (
    <nav className="ibn-navbar-wrapper">
      <div className="ibn-navbar-container">
        
        {}
        {/* Left Side: Solid White Logo Container */}
        <div className="ibn-logo-block">
          <a href="/" className="ibn-logo-link">
            <img 
              src="/assets/img/indiaboatslogo.png" 
              alt="India Boats" 
              className="ibn-logo-img" 
            />
          </a>
          {/* Angle element to seamlessly transition into the blue background */}
          <div className="ibn-logo-angle"></div>
        </div>

        {}
        {/* Middle: Modern MMT-Style Navigation Links (Hidden on Mobile) */}
        <div className="ibn-middle-links-section">
          {navLinks.map((link, index) => (
            <a key={index} href={link.url} className="ibn-nav-item">
              <span className="ibn-nav-icon">{link.icon}</span>
              <span className="ibn-nav-label">{link.name}</span>
              <span className="ibn-nav-underline"></span>
            </a>
          ))}
        </div>

        {}
        {/* Right Side: Premium CTA & Hamburger */}
       <div className="ibn-right-section">

  {/* Desktop Login Button */}
  <a href="/gift" className="ibn-cta-button ibn-desktop-login">
    {/* <LogIn size={14} className="ibn-cta-phone-icon" />
    <span>Login</span> */}
    <Gift size={14} className="ibn-cta-phone-icon" />
    <span>Gift Experience</span>
  </a>

  {/* Mobile Call Button */}
  <a
    href={`tel:${phoneNumber}`}
    className="ibn-cta-button ibn-mobile-call"
  >
    <Phone size={14} className="ibn-cta-phone-icon" />
    <span>Call Now</span>
  </a>

  {/* Hamburger */}
  <button
    className="ibn-hamburger-btn"
    onClick={toggleMobileMenu}
    aria-label="Toggle Menu"
  >
    {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
  </button>

</div>

      </div>

      {}
      {/* Mobile Menu Drawer (Fully structured and correctly closed) */}
      <div className={`ibn-mobile-drawer ${isMobileMenuOpen ? 'open' : ''}`}>
        <div className="ibn-drawer-overlay" onClick={toggleMobileMenu}></div>
        <div className="ibn-drawer-content">
          <div className="ibn-drawer-header">
            <div className="ibn-drawer-logo">
              <img src="/assets/img/indiaboatslogo.png" alt="" />
            </div>
            <button className="ibn-drawer-close" onClick={toggleMobileMenu}>
              <X size={24} />
            </button>
          </div>

          <div className="ibn-drawer-body">
            {navLinks.map((link, index) => (
              <a key={index} href={link.url} className="ibn-drawer-item" onClick={toggleMobileMenu}>
                <span className="ibn-drawer-icon">{link.icon}</span>
                <span className="ibn-drawer-label">{link.name}</span>
              </a>
            ))}
          </div>

          <div className="ibn-drawer-footer">
              <a href='/login' className="ibn-drawer-cta">
              <LogIn size={16} />
              <span>Login</span>
            </a>
            <a href={`tel:${phoneNumber}`} className="ibn-drawer-cta">
              <Phone size={16} />
              <span>Call Us Now</span>
            </a>
            <span className="ibn-drawer-phone-val">{phoneNumber}</span>
          </div>
        </div>
      </div>

      
   
      
    </nav>
  );
};

export default PremiumNavbar;